import { CircularProgress } from "@mui/material";
import { styled } from "styled-components";

export const Loader = ({ full = false }) => {
  return (
    <Wrapper className="flexCenter" full={full}>
      <CircularProgress size={30} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  height: ${(props) => (props.full ? "100vh" : "auto")};
  padding: ${(props) => !props.full && "20px"};
  width: 100%;
`;
